import { Sheets } from "common/sheets";
export class Title {
    constructor(pixiContext, sheets) {
        this.sprite = Sheets.animation(pixiContext, sheets, imageName);
        this.sprite.animationSpeed = 0.15;
    }
}
export const imageName = "title";
//# sourceMappingURL=title.js.map